<template>
    <div class="d-flex slot-pause" :class="{'not-editable': !canEdit}">
        <div class="time-info"></div>
        <div class="time-block pause-block">
            <span class="block-label">
                Pause ({{ pauseDuration }} min)
            </span>
            <button
                v-if="canEdit"
                class="add-appointment-btn"
                @click.stop="canEdit && $emit('add-appointment', day, startTime, endTime)"
                title="Ajouter un rendez-vous pendant cette pause"
                :disabled="!canEdit"
                :class="{'disabled': !canEdit}"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 13 12" fill="none">
                    <path d="M6.5 0.3125C5.37512 0.3125 4.2755 0.646066 3.3402 1.27102C2.40489 1.89597 1.67591 2.78423 1.24544 3.82349C0.814964 4.86274 0.702333 6.00631 0.921786 7.10958C1.14124 8.21284 1.68292 9.22626 2.47833 10.0217C3.27374 10.8171 4.28716 11.3588 5.39043 11.5782C6.49369 11.7977 7.63726 11.685 8.67651 11.2546C9.71577 10.8241 10.604 10.0951 11.229 9.1598C11.8539 8.2245 12.1875 7.12488 12.1875 6C12.1859 4.49207 11.5862 3.04636 10.5199 1.98009C9.45364 0.913821 8.00793 0.314092 6.5 0.3125ZM6.5 10.8125C5.54818 10.8125 4.61773 10.5303 3.82632 10.0014C3.03491 9.47264 2.41808 8.72103 2.05383 7.84166C1.68959 6.96229 1.59428 5.99466 1.77997 5.06113C1.96566 4.12759 2.42401 3.27009 3.09705 2.59705C3.77009 1.92401 4.6276 1.46566 5.56113 1.27997C6.49466 1.09428 7.4623 1.18958 8.34167 1.55383C9.22104 1.91808 9.97264 2.53491 10.5014 3.32632C11.0303 4.11773 11.3125 5.04818 11.3125 6C11.3111 7.27591 10.8036 8.49915 9.90135 9.40135C8.99915 10.3036 7.77591 10.8111 6.5 10.8125ZM9.125 6C9.125 6.11603 9.07891 6.22731 8.99686 6.30936C8.91481 6.39141 8.80353 6.4375 8.6875 6.4375H6.9375V8.1875C6.9375 8.30353 6.89141 8.41481 6.80936 8.49686C6.72731 8.57891 6.61603 8.625 6.5 8.625C6.38397 8.625 6.27269 8.57891 6.19064 8.49686C6.1086 8.41481 6.0625 8.30353 6.0625 8.1875V6.4375H4.3125C4.19647 6.4375 4.08519 6.39141 4.00314 6.30936C3.9211 6.22731 3.875 6.11603 3.875 6C3.875 5.88397 3.9211 5.77269 4.00314 5.69064C4.08519 5.60859 4.19647 5.5625 4.3125 5.5625H6.0625V3.8125C6.0625 3.69647 6.1086 3.58519 6.19064 3.50314C6.27269 3.42109 6.38397 3.375 6.5 3.375C6.61603 3.375 6.72731 3.42109 6.80936 3.50314C6.89141 3.58519 6.9375 3.69647 6.9375 3.8125V5.5625H8.6875C8.80353 5.5625 8.91481 5.60859 8.99686 5.69064C9.07891 5.77269 9.125 5.88397 9.125 6Z" fill="#555555"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import timeMixin from "../../Mixins/appointmentsMixin";

export default {
    name: "PauseBlock",
    mixins: [timeMixin],
    props: {
        pauseDuration: {
            type: Number,
            required: true
        },
        startTime: {
            type: String,
            required: true
        },
        endTime: {
            type: String,
            required: true
        },
        day: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    }
}
</script>
